import type { Session } from '../modules/session';

export interface SidebarMenuItem {
  key: string;
  route: string;
  icon: string;
  label: string;
  visible: (session: Session) => boolean;
  /** The screen exists for system-level credentials only; the entry carries the lock icon. */
  systemOnly?: boolean;
  hasSubItems?: boolean;
  subItems?: SidebarMenuItem[];
}

export const getSidebarMenuItems = (session: Session, organization: any): SidebarMenuItem[] => {
  const {
    isSystemAdmin,
    isOrganizationAdmin,
    isEventAdmin,
    isCampaignAdmin,
    isEventOrganizerAdmin,
    isCampaignOrganizerAdmin
  } = session;

  return [
    {
      key: 'home',
      route: '/',
      icon: 'home-01',
      label: 'Home',
      visible: () => true
    },
    // Organization Edit - Only for OrganizationAdmin users
    {
      key: 'org-edit',
      route: `/organizations/edit/${organization?.id}/about`,
      icon: 'building-01',
      label: 'Org settings',
      visible: () => isOrganizationAdmin && organization?.id
    },
    {
      key: 'campaigns',
      route: '/campaigns/live', // Default to Live campaigns
      icon: 'bar-chart-square-02',
      label: 'Campaigns',
      visible: () => isOrganizationAdmin || isSystemAdmin || isCampaignAdmin || isEventAdmin || isCampaignOrganizerAdmin
    },
    {
      key: 'fundraisers',
      route: '/fundraisers/all', // Default to All fundraisers
      icon: 'users-03',
      label: 'Fundraisers',
      visible: () => isOrganizationAdmin || isSystemAdmin || isCampaignAdmin || isEventAdmin || isCampaignOrganizerAdmin
    },
    {
      key: 'donations',
      route: '/donations',
      icon: 'coins-stacked-01',
      label: 'Donations',
      visible: () => isSystemAdmin || isOrganizationAdmin
    },
    {
      key: 'recurring',
      route: '/recurring/all', // Default to All recurring
      icon: 'repeat-04',
      label: 'Recurring',
      visible: () => isSystemAdmin || isOrganizationAdmin
    },
    {
      key: 'sales',
      route: '/sales',
      icon: 'ticket-01',
      label: 'Sales',
      visible: () => isSystemAdmin || isOrganizationAdmin || isCampaignAdmin || isCampaignOrganizerAdmin
    },
    {
      key: 'vip-program',
      route: '/vip-program/programs',
      icon: 'award-01',
      label: 'PlaceHub',
      visible: () => isSystemAdmin || isOrganizationAdmin || isCampaignAdmin || isEventAdmin || isEventOrganizerAdmin || isCampaignOrganizerAdmin
    },
    {
      key: 'content-moderation',
      route: '/content-moderation',
      icon: 'shield-tick',
      label: 'Moderation',
      visible: () => isSystemAdmin,
      systemOnly: true
    },
    {
      key: 'accounts',
      route: `/accounts/${isSystemAdmin ? 'all' : 'admins'}`, // Default to All for Sysadmin, Admins for everyone else
      icon: 'user-02',
      label: 'Accounts',
      visible: () => isSystemAdmin || isOrganizationAdmin
    },
    {
      key: 'events',
      route: '/events/live',
      icon: 'clock-stop-watch-01',
      label: 'Events',
      visible: () => isSystemAdmin || isEventAdmin || isEventOrganizerAdmin
    },
    {
      key: 'organizations',
      route: '/organizations',
      icon: 'building-01',
      label: 'Organisations',
      visible: () => isSystemAdmin,
      systemOnly: true
    },
    {
      key: 'tap-n-donate',
      route: '/tap-n-donate/assigned',
      icon: 'credit-card-01',
      label: 'TapNDonate',
      visible: () => isSystemAdmin,
      systemOnly: true
    }
  ];
};

export const getBottomMenuItems = (session: Session, currentUserId: string): SidebarMenuItem[] => {
  return [];
};
